import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions from "../../utils/useWindowDimensions";

const BarChart = ({ list }) => {
  const [chartData, setChartData] = useState({
    series: [],
    options: {},
  });

  let { width } = useWindowDimensions();

  useEffect(() => {
    if (list) {
      setChartData({
        series: [
          {
            name: "Score",
            data: list?.map((e) => e.score),
          },
        ],
        options: {
          chart: {
            type: "bar",
            height: 300,
            toolbar: {
              show: false,
            },
          },
          colors: ["#06D001", "#ff0000"],
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: list?.map((e) => e?.region || 'N/A'),
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetY: 0,
            offsetX: -35,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },
        },
      });
    }
  }, [list]);

  if (!list) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div id="chart">
        <ReactApexChart
          options={chartData.options}
          series={chartData.series}
          type="bar"
          height={width > 1700 ? 382 : 282}
        />
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default BarChart;
